const CSS_VAR_RE = /^var\((--[a-z0-9-]+)\)$/i

/** 'var(--color-accent)' | '--color-accent' → вычисленное значение из :root. */
export function resolveThemeToken(token: string): string {
  if (typeof window === 'undefined') {
    return ''
  }

  const match = CSS_VAR_RE.exec(token.trim())
  const cssVarName = match ? match[1]! : token

  return window.getComputedStyle(document.documentElement).getPropertyValue(cssVarName).trim()
}
